//引入Vue
import Vue from "vue";
//引入App
import App from './App';
// 引入Store
import store from './store'
//引入 vue-router
import VueRoutter from 'vue-router';
// 引入 router 对象
import router from './router'
// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// 引入动画
import 'animate.css'
// import animate from 'animate.css'
// Vue.use(animate);
// 引入mixin主
import { mixin, shareData } from "@/js/mixin";
Vue.mixin(mixin);// Vue.mixin(shareData);
//引入判断函数
import regular from '@/js/regular.js';
Vue.prototype.$regular = regular;
//全局过滤器
import filters from '@/js/filter.js';
Object.keys(filters).forEach(key=>{
    Vue.filter(key,filters[key])
})
//关闭Vue的生产提示
Vue.config.productionTip = false;
Vue.use(VueRoutter)
// Vue
new Vue({
    el: '#app',
    render: h => h(App),
    store,
    router,
    beforeCreate(){
        Vue.prototype.$bus = this
    },
});

